<template>
  <div class="progress-bar relative" :class="showNull ? 'null-bar' : ''">
    <span
      class="absolute left-0 right-0 top-0 bottom-0 m-auto h-full flex items-center justify-center"
      style="min-width: 50px; filter: contrast(0.2); mix-blend-mode: difference"
      >{{ showNull ? "-" : progress + "%" }}</span
    >
    <div
      class="progress flex items-center justify-center"
      :style="{ width: animatedProgress + '%' }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    progress: {
      type: Number,
      default: 0,
      required: true,
    },
    showNull: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      animatedProgress: 0,
    };
  },
  mounted() {
    this.animateProgress();
  },
  watch: {
    progress(newValue) {
      this.animateProgress(newValue);
    },
  },
  methods: {
    animateProgress(value = this.progress) {
      setTimeout(() => {
        this.animatedProgress = value;
      }, 100); // Delay to ensure animation on mount
    },
  },
};
</script>

<style scoped>
.progress-bar {
  direction: ltr;
  width: 100%;
  max-width: 200px;
  min-width: 130px;
  height: 30px;
  background-color: #f386868f;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}
.null-bar {
  background: linear-gradient(
    45deg,
    rgba(122, 122, 122, 0.205) 25%,
    rgba(141, 141, 141, 0.202) 25%,
    rgba(141, 141, 141, 0.202) 50%,
    rgba(122, 122, 122, 0.205) 50%,
    rgba(122, 122, 122, 0.205) 75%,
    rgba(141, 141, 141, 0.202) 75%,
    rgba(141, 141, 141, 0.202)
  );
  background-size: 3rem 3rem;
}

.progress {
  height: 100%;
  background: linear-gradient(
    45deg,
    rgba(0, 114, 66, 0.801) 25%,
    rgba(1, 141, 48, 0.692) 25%,
    rgba(1, 141, 48, 0.692) 50%,
    rgba(0, 114, 66, 0.801) 50%,
    rgba(0, 114, 66, 0.801) 75%,
    rgba(1, 141, 48, 0.692) 75%,
    rgba(1, 141, 48, 0.692)
  );
  background-size: 3rem 3rem; /* Adjusted to make stripes larger */
  animation: progress-animation 10s linear infinite;
  transition: width 0.8s; /* Added transition for width */
}

@keyframes progress-animation {
  from {
    background-position: 0 0; /* Adjusted to match the larger stripe size */
  }
  to {
    background-position: 3rem 0;
  }
}
</style>
